<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
  ><g clip-path="url(#a)"><path
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1.75"
    d="M11.923 9.836c1.592 2.92 5.4 2.816 6.403 2.816M5.617 22.807l-2.997-.008V12.067C1.34 10.61 1.105 9.465 1.214 6.973c.88.816 2.833 3.033 4.218 3.25l5.077.105c.71.06 1.39-.3 1.75-.91 1.496-3.008.458-8.344 4.504-8.224v2.63l6.077 1.965s.65 4.77-4.482 4.77l-.002 12.25-3.245-.01-1.402-5.288H7.355l-1.738 5.296Z"
  /></g><defs><clipPath id="a"><path
    fill="none"
    d="M0 0h24v24H0z"
  /></clipPath></defs></svg>
</template>
